export default function (rawValue) {
  if (rawValue.replace(/(_|\.)/g, '').length >= 5) {
    return [
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
    ];
  }
  if (rawValue.replace(/(_|\.)/g, '').length >= 4) {
    return [
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
    ];
  }
  return [
    /\d/,
    /\d/,
    /\d/,
  ];
}
